import React from 'react'

export default {
  hasError: (fieldName, errorArray = []) => {
    return errorArray.find(e => e.field === fieldName)
  },
  signupError: (fieldName, errorArray = []) => {
    const errors = errorArray.filter(e => e.field === fieldName)
    if (errors) {
      return errors.map((e, i) => (
        <p key={`${fieldName}-uierror-${i}`} className="signup-box__required">
          <i className="fa fa-exclamation-circle" />
          {e.message}
        </p>
      ))
    }

    return null
  },
  settingError: (fieldName, errorArray = []) => {
    const errors = errorArray.filter(e => e.field === fieldName)
    if (errors) {
      return errors.map((e, i) => (
        <p
          key={`${fieldName}-uierror-${i}`}
          className="business-reservation-setting__required"
        >
          <i className="fa fa-exclamation-circle mr5" />
          {e.message}
        </p>
      ))
    }

    return null
  },
}
